import update from 'react-addons-update';
import { i18n } from 'core/i18n';
import {
	HOME_SEARCH_BOOKINGS_SUCCESS,
	HOME_CLEAN_BOOKINGS,
	HOME_GET_BOOKING_DATA_SUCCESS,
	HOME_CLEAN_BOOKING_DATA
} from './action.js';

const initState = {
	action: null,
	bookingRows: [],
	bookingData: null,
	translationData: null
};

export default function homeReducer(state = initState, action) {
	switch (action.type) {
		case HOME_SEARCH_BOOKINGS_SUCCESS:
			let bookingRows = action.data;
			bookingRows.map((item) => {
				if (item === null) {
					bookingRows = [];
					return true;
				};
				if (item.flightNumbers && item.flightNumbers.length !== 0) {
					let flightNumberString = '';
					item.flightNumbers.forEach((flightNumbersItem, flightNumbersIndex) => {
						if (flightNumbersIndex === 0){
							flightNumberString += flightNumbersItem;
						}else{
							flightNumberString += ` - ${flightNumbersItem}`;
						}
					});
					item.bookingReference = `${item.bookingReference} (${flightNumberString})`;
				}
				item.event = {
					bookingReference: item.bookingReference ? item.bookingReference : '',
					editable: !item.allFlown && item.bookingStatus !== 'holdCanceled',
					printable: item.bookingStatus === 'confirmed'
				}
				return true;
			});
			switch (action.tab) {
				case 1:
					bookingRows = bookingRows.filter(function (item) {
						return item.bookingStatus && item.bookingStatus === 'confirmed';
					});
					break;
				case 2:
					console.log(action.tab)
					break;
				case 3:
					console.log(action.tab)
					break;
				default:
					break;
			}
			if (bookingRows.length === 0) {
				bookingRows = [
					{ bookingReference: i18n('no_booking_reference') }
				];
			}
			return update(state, {
				action: { $set: action.type },
				bookingRows: { $set: bookingRows }
			});
		case HOME_CLEAN_BOOKINGS:
			return update(state, {
				action: { $set: action.type },
				bookingRows: { $set: [] }
			});
		case HOME_GET_BOOKING_DATA_SUCCESS:
			return update(state, {
				action: { $set: action.type },
				bookingData: { $set: action.data }
			});
		case HOME_CLEAN_BOOKING_DATA:
			return update(state, {
				action: { $set: action.type },
				bookingData: { $set: null }
			});
		default:
			return state;
	}
}